import { COLORS } from 'src/theme/palette';
import { SxStyles } from 'src/types/theme';

const styles: SxStyles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
  },
  goToSelectContainer: {
    marginLeft: '20px',
    display: 'flex',
    alignItems: 'center',
  },
  goToSelectLabel: {
    color: COLORS.black40,
    marginRight: '10px',
  },
  goToSelect: {
    '& > .MuiSelect-select': {
      boxSizing: 'border-box',
      minWidth: '61px',
      padding: '6px 12px',
      borderColor: COLORS.black20,
      borderRadius: '6px',
    },
    '& svg': {
      fill: COLORS.black80,
      top: '13px',
    },
  },
};

export default styles;
